/* Order here is important. */
@layer reset {
  html,
  body {
    box-sizing: border-box;

    /* Match Figma's rendering */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  button {
    font-family: inherit;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body,
  fieldset,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  pre,
  ol,
  ul,
  dl,
  dt,
  dd {
    font-weight: normal;
    margin: 0;
    padding: 0;
  }

  ul,
  ol {
    list-style: none;
  }
}
